import { compose } from 'recompose'
import { withRouter } from 'react-router-dom'

import Component from './component'
import withTranslation from '../../../globals/components/withTranslation'
import withPermissions from '../../../globals/components/withPermissions'

export default compose(withPermissions, withTranslation, withRouter)(Component)
